import { useEffect, useRef } from 'react';

const CODE_VIEW_POLL_MS = 1000;

/**
 * Froala fires no change events while its code (html) view is active, so the
 * content is polled instead.
 *
 * Calls `onCodeViewChange(html)` every second while the code view is active.
 * Nothing is reported while the code view is closed.
 *
 * @param editorRef ref holding the Froala editor instance
 * @param onCodeViewChange optional callback, may change between renders
 */
export function useHtmlCodeViewChanges(editorRef, onCodeViewChange) {
  const callbackRef = useRef(onCodeViewChange);
  callbackRef.current = onCodeViewChange;

  useEffect(() => {
    const pollId = setInterval(() => {
      const codeView = editorRef.current?.codeView;

      if (codeView?.isActive()) {
        callbackRef.current?.(codeView.get());
      }
    }, CODE_VIEW_POLL_MS);

    return () => clearInterval(pollId);
  }, [editorRef]);
}
